import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import store, { persistor } from './redux/store';

import ProtectedRoute from './components/containers/ProtectedRoute';

import SignInPage from './components/pages/anon/SignIn';
import SignUpPage from './components/pages/anon/SignUp';
import ForgotPasswordPage from './components/pages/anon/ForgotPassword';
import ResetPasswordPage from './components/pages/anon/ResetPassword';

import CollectionsRootPage from './components/pages/collections/CollectionsRootPage';
import ContactsRootPage from './components/pages/contacts/ContactsRootPage';
import DashboardPage from './components/pages/dashboard/DashboardPage';
import FinancialsPage from './components/pages/financials/FinancialsPage';
import AccountPage from './components/pages/AccountPage';

import NotFoundPage from './components/NotFound';
import Loading from './components/common/Loading';

import './App.css';

const App = () => (
  <Provider store={store}>
    <PersistGate loading={<Loading />} persistor={persistor}>
      <Router>
        <Switch>
          <ProtectedRoute exact path="/" component={CollectionsRootPage} />

          <ProtectedRoute path="/collections" component={CollectionsRootPage} />
          <ProtectedRoute path="/dashboard" component={DashboardPage} />
          <ProtectedRoute path="/financials" component={FinancialsPage} />
          <ProtectedRoute path="/contacts" component={ContactsRootPage} />
          <ProtectedRoute path="/settings" component={AccountPage} />

          <Route path="/sign-in" component={SignInPage} />
          <Route path="/sign-up" component={SignUpPage} />
          <Route path="/forgot-password" component={ForgotPasswordPage} />
          <Route path="/reset-password" component={ResetPasswordPage} />

          <Route path="/404" component={NotFoundPage} />
          <Route component={NotFoundPage} />
        </Switch>
      </Router>
    </PersistGate>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx